import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";
import { PageContent } from "./PageContent";

export interface DetailPageContentProps {
  children: ReactNode;
  className?: string;
}

/**
 * The body of a submission detail page — whatever follows `DetailPageTopBar`.
 *
 * `PageContent`'s `pt-8 pb-8` suits list pages, but under the detail header it pushed the
 * tabs down in every vertical except Broker AI, which overrode it inline (IQ-119). The
 * tighter spacing lives here so every detail page starts its content at the same offset.
 */
export function DetailPageContent({ children, className }: DetailPageContentProps) {
  return <PageContent className={cn("pt-4 pb-4", className)}>{children}</PageContent>;
}
